import request from "@src/util/request";
// import store from '@src/util/store';
import { isEmpty } from "@src/util";
import { API_CALCULATOR, 
    API_GET_LIAISON,
    API_GET_QUALIFICATION, 
    API_HAS_LOAN_AND_QUA_STATUS, 
    API_ISAPPLY, 
    API_SUBMIT_INSURED ,
    API_GET_STATUS,
    API_CF_ORDER_LIST,
    API_GETLON,
    API_LOAD_LIST,
    API_APPLY_APPROVAL_GET,
    API_MILOAD_LIST,
    API_CHECK_QUA_STATUS} from "@src/config/api";
import { SOURCE} from "@src/config/index";

// type calTypa = {
//   "carPrice": number,
//   "downPayment": number,
//   "stagingTime": number,
//   "source"?: string,
//   "robberyProtectionFee"?: number
// }

/**
 * 金融计算器
 * @param obj 
 * @returns 
 */
export function getCalVal(obj:any) {
  return request.post(API_CALCULATOR, { ...obj,'source':SOURCE}).then(rs => rs.data).then(
    res => {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    }
  )
}

// 查询 是否有融租单记录 及 资格预审状态
export async function hasLoanAndQuaStatus() {
	const form = new FormData()
	form.append('source', SOURCE)
	return request.post(API_HAS_LOAN_AND_QUA_STATUS, form).then(rs=>rs.data).then(
    res => {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    })
}

// 判断分期申请状态
export function preSubmitInsured() {
  return request.get(`${API_ISAPPLY}?source=${SOURCE}`).then(rs=>rs.data).then(
    res => {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    }
  )
}

/**
 * 查询资格审核结果
 */
 export function qualificationResult() {
	const form = new FormData()
	form.append('source', SOURCE)
	return request.post(API_GET_QUALIFICATION, form).then(rs=>rs.data).then(
    res => {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    }
  )
}

/**
 * 根据分期申请id获取申请人和联系人相关信息
 * @param id 
 * @returns 
 */
export function getOriginApplyLoans(id:string) {

  return request.get(`${API_GET_LIAISON}?loanid=${id ? encodeURIComponent(id) : ''}`).then(rs=>rs.data).then(
    res => {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    })
}

/**
 * 保存申请人和联系人相关信息
 * @param form
 * @returns 
 */
 export function submitInsured(form:any) {
  return request.post(API_SUBMIT_INSURED, form).then(rs=>rs.data).then(
    res => {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    })
}

/**
 * 获取用户状态
 * @returns 
 */
export function getState() {
  return request.get(`${API_GET_STATUS}?source=${SOURCE}`).then(rs=>rs.data).then(
    res=> {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    }
  )
}

/**
 * 获取分期申请列表
 * @param source 
 * @param state 
 * @returns 
 */
export function getOrderList(source = SOURCE, state?: "0" | "1" | "9") {
	return request.get(API_CF_ORDER_LIST, {params: {source: source, state}}).then((rs) => rs.data).then(
    res=> {
      if (res.errcode == 0 && !isEmpty(res.data)) {
        return res.data
      }
    }
  )
}

/**
 * 获取金融方案列表
 * @param params
 */
 export function loadList(params: any) {
	return request.post(API_LOAD_LIST, {...params,source:SOURCE}).then((rs) => rs.data).then((rs) => rs.data);
}
/**
 * 获取我的金融方案
 * @param id 
 * @returns 
 */
export function miLoadList(id: any) {
  return request.get(API_MILOAD_LIST,{params:{loaningInfoId:id}}).then((rs) => rs.data);
}

/**
 * 获取分期申请状态
 * @param params
 */
 export function getfzzt(loanid: string) {
	return request.get(`${API_GETLON}?loanid=${loanid ? encodeURIComponent(loanid) : ''}`).then((rs) => rs.data).then((rs) => rs.data);
}
/**
 * 获取用户通过的流程
 * @param loanid 
 * @returns 
 */
export function getOrderApproval(loanid: string) {
	return request.get(API_APPLY_APPROVAL_GET, {params: {loanid}}).then((rs) => rs.data);
}
// 查询当前申请信息
export function checkQuaStatus() {
	const form = new FormData()
	form.append('source', SOURCE)
	return request.post(API_CHECK_QUA_STATUS, form).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}
/**
 *
 * @param url
 * @param params
 */
 export function loadReason(url: string, params: any) {
	return request.post(url, params).then((rs) => rs.data);
}

/**
 *
 * @param url
 * @param params
 */
 export function getContractDetail(url: string, params: any) {
	return request.get(url, params).then((rs) => rs.data);
}